import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { h, c } from '@debbie/cortex/dist';
import VoucherApplication from './VoucherApplication';
const VoucherApplications = (props) => {
    const lang = useSelector((s) => s.lang);
    const voucherApplications = useSelector((s) => s.voucherApplications[props.tenantId]);
    const relevantCreditorId = props.creditorId || null;
    useEffect(() => {
        if (h.isNotLoaded(voucherApplications)) {
            c.voucherApplications.getVoucherApplications(props.tenantId);
        }
    }, [props.tenantId]);
    return (React.createElement(Wrapper, null, h.hasData(voucherApplications)
        ? voucherApplications.data
            .filter((va) => va.creditorId == relevantCreditorId)
            .map((va) => {
            return React.createElement(VoucherApplication, { key: va.id, voucherApplication: va });
        })
        : null));
};
const Wrapper = styled.div ``;
export default VoucherApplications;
//# sourceMappingURL=VoucherApplications.js.map